// extracted by mini-css-extract-plugin
export default {"root":"RrAhnHU7","title":"CNI6amMN","description":"Y41I8Srm","button":"ddfQUFFc","content":"q0v_jEUh"};